import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import ProfileComponent from './users-profile-url.component';

export const UsersBasicInfoComponent = ({
    selectusers, handleInnerFormChange, handleBasicFormChange, changeProfileImage
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-3 gap-4'>

                        <InputContainer
                            label="FirstName"
                            isDisabled
                            labelField="FirstName"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'FirstName'
                                );
                            }}
                            type="text"
                            value={selectusers?.FirstName}
                        />

                          <InputContainer
                            label="LastName"
                            isDisabled
                            labelField="LastName"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'LastName'
                                );
                            }}
                            type="text"
                            value={selectusers?.LastName}
                        />

                        

                        <InputContainer
                            label="Active"
                            isDisabled
                            labelField="IsActive"
                            onValueChange={(event: any, newValue: any) => {
                                handleBasicFormChange(
                                    event,
                                    'IsActive',
                                    selectusers?.BasicInfo
                                )
                            }}
                            type="checkbox"
                            value={selectusers?.IsActive}
                        />



                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />

            <AccordionContainer
                            child={
                                <div>
                                    <ProfileComponent
                                        selectusers={selectusers}
                                        changeProfileImage={changeProfileImage}
                                    />
            
                                </div>
                            }
                            expandedPanel="profile"
                            headerTitle="Profile"
                        />
        </>
    )
}

export default UsersBasicInfoComponent;
